export function getExtension(src = '') {
  // Extract everything after the final dot, e.g. .jpg, .png, .webp, ...
  // If there's no extension, default to jpg or whatever works for your workflow.
  const parts = src.split('.');
  if (parts.length > 1) {
    return parts.pop().toLowerCase();
  }
  return 'jpg';
}

export function removeExtension(src = '') {
  // Remove the extension from the end. E.g. 'example.png' -> 'example'
  const extension = getExtension(src);
  return src.replace(`.${extension}`, '');
}

/**
 * Utility to build a final image URL given a base path and extension
 */
export function buildSrc(baseUrl = '', extension = 'jpg') {
  return `${baseUrl}.${extension}`;
}

/**
 * Example: transform a "512" URL to "256" for smaller screens
 */
export function replaceSizeInUrl(src = '', oldSize = '512', newSize = '256') {
  return src.replace(oldSize, newSize);
}
